import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { WhiteLabelService } from '../../../shared/services/white-label.service'

export const v3SkinGuard: CanActivateFn = () => {
	const router = inject(Router)
	const whiteLabelService = inject(WhiteLabelService)

	return whiteLabelService.isV3Skin() ? true : router.parseUrl('/home')
}
